import browser from "web/script/utils/browser";

export default {
    send(data) {
        data.forEach((event) => {
            if (
                event.type !== "event" ||
                !browser.ios ||
                (event.data.page_type !== "feed" && event.data.page_type !== "search")
            ) {
                return Promise.resolve();
            }
        });
        // no way of waiting for this to be done
        return Promise.resolve();
    },
};
